import * as React from 'react';
import Slider from '@mui/material/Slider';

function valuetext(value) {
  return `${value}m`;
}

export default function RangeSlider({ value, min, max, step, onChange }) {
  return (
    <Slider
      value={value}
      min={min}
      max={max}
      step={step}
      onChange={onChange}
      valueLabelDisplay="auto"
      getAriaValueText={valuetext}
      disableSwap
    />
  );
}
